import { Component, inject } from '@angular/core';
import { ButtonDirective, ButtonIcon, ButtonLabel } from 'primeng/button';
import { Tag } from 'primeng/tag';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-forbidden-page',
  imports: [Tag, ButtonDirective, ButtonIcon, ButtonLabel],
  templateUrl: './forbidden-page.component.html',
  styleUrl: './forbidden-page.component.scss',
})
export class ForbiddenPageComponent {
  userService = inject(UserService);

  goBack() {
    window.history.back();
  }

  async logout() {
    await this.userService.logout();
  }

  async redirectToLogin() {
    this.userService.redirectToLogin('/quotes');
  }
}
